import { Component, HostListener, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, combineLatest } from 'rxjs';
import { CryptoService} from '../../../services/crypto.service';
import * as fromFeature from '../../../my-features';
import { PackageList, SourceType, ReLoadDashboardSec } from '../../../shareModel';
import { TreeNode } from 'primeng/api';
import { BatteryReplacement} from '../../../my-features/battery-replacement/battery-replacement.model';
import { EventMonitoringFilter } from '../../../models/events';
import { User } from '../../../models/user';
import { Router } from '@angular/router';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { DeviceMonitoringFilter } from '../../../models/devices';
import { MspRegion } from '../../../my-features/region/region.model';
import { PreferenceService } from '../../../services/preference.service';
import { switchMap, take, takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.UI();
  }
  private componentDestroyed = new Subject();
  groupFeature: Boolean;
  isMsp: Boolean;
  device_regionId: number;
  batteryReplacementInfo: BatteryReplacement = {
    expires: false
  };
  SourceType = SourceType;
  sn: string;
  curDate = new Date();
  mspSelectedRegionId = [];
  UserParam = {} as User;
  NotMspDeviceInfoIsRead = false;

  devicesTypeCount: any[] = [];
  devicesTypeCount_Region: any[] = [];
  devicesTypeCountGrid = [{}, {}, {}, {}, {}];
  devicesTypeCountGrid_Region = [{}, {}, {}, {}, {}];
  devicesTypeCountGridLoaing = [{"label": "Normal"}, {"label": "Warning"}, {"label": "Critical"}, {"label": "Offline"}];
  selectedStatus: any = {};

  deviceList$: Observable<any>;
  deviceGroupList$: Observable<TreeNode[]>;
  deviceGroupList = [];
  deviceGroupListStash = [];
  warningKeyWord: string = '';
  criticalKeyWord: string = '';
  allDeviceWarningList = [];
  allDeviceCriticalList = [];
  allDeviceWarningListStash = [];
  allDeviceCriticalListStash = [];
  deviceWarningList = [];
  deviceCriticalList = [];
  deviceWarningListStash = [];
  deviceCriticalListStash = [];
  selectedWaringDevice: any;
  selectedCriticalDevice: any;

  deviceDetailSidebar = false;
  deviceDetail: any = {};
  deviceDetails$: Observable<any>;
  eventLogs$: Observable<any>;
  eventLogs: any = [];
  eventLogsDetail: any = [];
  eventLogs_cols: any[] = [
    { field: 'status', header: TRANSLATE('Status'), width: '80', class: 'col-nowrap text-center', disabled: false },
    { field: 'time', header: TRANSLATE('Time'), width: '170', class: 'col-nowrap', disabled: false },
    { field: 'timezoneLabel', header: TRANSLATE('Time Zone'), width: '150', class: 'hidden-sm', disabled: false },
    { field: 'name', header: TRANSLATE('Device Name'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'type', header: TRANSLATE('Type'), width: '120', class: 'col-nowrap', disabled: false },
    { field: 'desc', header: TRANSLATE('Description'), width: '420', class: 'col-nowrap', disabled: false },
  ];
  boardListHeight: string;
  eventListHeight: string;
  sideEventListHeight: string;
  region: MspRegion[];
  treeRegion: any[] ;
  selectedRegion: any = null;
  selectedEvent: any = null;
  ReadRegionParam: {
    MspMainRegionId: number
    otp: string;
  };
  filterDeviceParam: DeviceMonitoringFilter = {
    // device_status: 2,
    // multiDevice_status: ['Warning', 'Critical'],
    device_status: [0, 1, 2, 3],
    regionId: -1,
    DeviceSubType: []
  };
  filterEventParam: EventMonitoringFilter = {
    // device_status: 2,
    startDate: new Date(this.curDate.getTime() - 24 * 60 * 60 * 1000 ),
    endDate: new Date()
  };
  intervalId: any = null;
  statusString: string;
  refreshTime: Date = new Date();
  allDeviceStatus = [];
  eventLog_Dic = [];
  regionFilter: any;
  HashDcode: any;
  pageLoading: boolean = true;
  IsSuperAdmin = false;
  regionLoaded = false;
  acode: number;
  constructor(
    private ngxService: NgxUiLoaderService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private store: Store<fromStore.State>,
    public preferenceService: PreferenceService,
    private cryptoService: CryptoService,
    private router: Router,
    ) {

    // For Pro Overview Get MspMainRegionId
    this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined) {
        this.isMsp = res.isMsp;
        if (!res.isMsp) {
          this.router.navigate(['/index']);
        }
        this.IsSuperAdmin = res.authority && res.authority === 2 ? true : false;
        this.acode = res.acode;
      }
    });

    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!this.regionLoaded && res !== undefined && res.length > 0) {
        if (
          this.isMsp && this.IsSuperAdmin === false) {
          const mspMainRegionItem = res.find(r => r.Admins !== undefined && r.Admins.filter(i => i === this.acode) !== undefined);
          const mspMainRegionId = mspMainRegionItem !== undefined ? mspMainRegionItem.MspMainRegionId : undefined;
          this.ReadRegionParam = {
            MspMainRegionId: mspMainRegionId,
            otp: ''
          };
          this.getMspRegion();
          this.regionLoaded = true;
        }
      }
    });

    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // this.RangeParam.RegionIds = null;
      if (res !== null) {
        if (res.isMsp && res.filterLoaded) {
          this.regionFilter = res;
          this.refresh();
          this.startInterval();
        }
      }
    });

    // this.store.select(fromStore.getMspRegion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
    //   if (res !== undefined) {
    //     this.region = res;
    //   }
    // });

    // Get Event Monitoring Data
    this.store.select(fromStore.getProEventMonitoringData).pipe(takeUntil(this.componentDestroyed)).subscribe(event_monitoring => {
      this.eventLog_Dic = [];
      if (event_monitoring !== undefined && event_monitoring !== null && event_monitoring.length > 0) {
        for ( const e in event_monitoring) {
          let event_item = event_monitoring[e];
          if (event_item !== null) {
            if (this.eventLog_Dic[event_item.RegionId] === undefined) {
              this.eventLog_Dic[event_item.RegionId] = [];
            }
            event_item = {
              ...event_item,
              timeformat: new Date(Number(event_item.timestamp) * 1000)
            }
            this.eventLog_Dic[event_item.RegionId].push(event_item)
          }
        }
      }
    });


    combineLatest(this.store.select(fromStore.getMspRegion),
        this.store.select(fromStore.getDeviceMonitoring)).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getMspRegion, getDeviceMonitoring]) => {
      this.pageLoading = true;
      if (getMspRegion !== undefined) {
        this.region = getMspRegion;
        if (getDeviceMonitoring !== undefined && getDeviceMonitoring !== null) {
          const device_status_list = [];
          if (getDeviceMonitoring.length > 0) {
            this.allDeviceStatus = [];
            for( const i in getDeviceMonitoring) {
              const item = getDeviceMonitoring[i];
              if (item !== null) {
                if( device_status_list[item.regionId] == undefined ) {
                  device_status_list[item.regionId] = {
                    all : {
                      device_list : [],
                      all_count : 0
                    },
                    normal : {
                      device_list : [],
                      normal_count : 0
                    },
                    warning : {
                      device_list : [],
                      warning_count : 0
                    },
                    critical : {
                      device_list : [],
                      critical_count : 0
                    },
                    offline : {
                      device_list : [],
                      offline_count : 0
                    },
                    data: []
                  }
                }
                // 取出所有region的device後分群
                if (item.device_status == 0) { // normal
                  device_status_list[item.regionId].normal.normal_count += 1;
                  device_status_list[item.regionId].normal.device_list.push(item);
                } else if (item.device_status == 1) { // warning
                  device_status_list[item.regionId].warning.warning_count += 1;
                  device_status_list[item.regionId].warning.device_list.push(item);
                } else if (item.device_status == 2) { // critical
                  device_status_list[item.regionId].critical.critical_count += 1;
                  device_status_list[item.regionId].critical.device_list.push(item);
                } else if (item.device_status == 3) { // offline
                  device_status_list[item.regionId].offline.offline_count += 1;
                  device_status_list[item.regionId].offline.device_list.push(item);
                }
                device_status_list[item.regionId].all.all_count += 1;
                device_status_list[item.regionId].all.device_list.push(item);
              }
            }
          } else {
            if (this.region !== undefined && this.region.length > 0) {
              this.region.map(m =>{
                if( device_status_list[m.Id] == undefined ) {
                  device_status_list[m.Id] = {
                    all : {
                      device_list : [],
                      all_count : 0
                    },
                    normal : {
                      device_list : [],
                      normal_count : 0
                    },
                    warning : {
                      device_list : [],
                      warning_count : 0
                    },
                    critical : {
                      device_list : [],
                      critical_count : 0
                    },
                    offline : {
                      device_list : [],
                      offline_count : 0
                    },
                    data: []
                  }
                }
              })
            }
          }
          if (device_status_list !== null && device_status_list.length > 0) {
            let all_region_all_device_count = 0;
            let all_region_normal_device_count = 0;
            let all_region_warning_device_count = 0;
            let all_region_critical_device_count = 0;
            let all_region_offline_device_count = 0;
            for (const i in device_status_list) {
              let item = device_status_list[i];
              if (item !== null) {
                item.data = [
                  { label: TRANSLATE('All'), value: '-1', title: item.all.all_count },
                  { label: TRANSLATE('Normal'), value: '0', title: item.normal.normal_count },
                  { label: TRANSLATE('Warning'), value: '1', title: item.warning.warning_count },
                  { label: TRANSLATE('Critical'), value: '2', title: item.critical.critical_count },
                  { label: TRANSLATE('Offline'), value: '3', title: item.offline.offline_count }
                ];
                all_region_all_device_count += item.all.all_count;
                all_region_normal_device_count += item.normal.normal_count;
                all_region_warning_device_count += item.warning.warning_count;
                all_region_critical_device_count += item.critical.critical_count;
                all_region_offline_device_count += item.offline.offline_count;
              }
            }
            this.devicesTypeCount = [
              {label: TRANSLATE('All'), value: '-1', title: all_region_all_device_count},
              {label: TRANSLATE('Normal'), value: '0', title: all_region_normal_device_count},
              {label: TRANSLATE('Warning'), value: '1', title: all_region_warning_device_count},
              {label: TRANSLATE('Critical'), value: '2', title: all_region_critical_device_count},
              {label: TRANSLATE('Offline'), value: '3', title: all_region_offline_device_count}]
          }
          this.allDeviceStatus = device_status_list;
          this.getTreeRegion();
          this.ngxService.stop();
          this.pageLoading = false;
        }
      }
    })

    // Get Monitoring Details
    this.store.select(fromStore.getMonitoringDeviceDetails).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res != null) {
        this.deviceDetail.dcode = Number(res.dcode);
        this.HashDcode = this.cryptoService.aesEncrypt(res.dcode);
        this.deviceDetail.Brand = Number(res.dcode);
        this.deviceDetail.name = res.name;
        this.deviceDetail.desc = res.desc;
        this.deviceDetail.icon = res.icon;
        this.deviceDetail.region = res.timeZone;
        this.deviceDetail.deviceDescription = res.desc;
        if (res.image) {
          if (!res.image.includes('/undefined')) {
            this.deviceDetail.image = res.image;
            this.deviceDetail.imageClass = 'sidebar-content-detail-img-bgWhite';
          } else {
            this.deviceDetail.image = '/assets/images/default_device.png';
            this.deviceDetail.imageClass = 'sidebar-content-detail-img-bgGray';
          }
        }
        this.deviceDetail.status = res.status;
        this.deviceDetail.hardwarefault = res.hardwarefault;

        this.deviceDetail.type = res.type;
        this.deviceDetail.subtype = res.subtype;
        this.deviceDetail.sourcetype = res.SourceType;
        this.deviceDetailSidebar = true;
        
        // 只取前20筆
        this.eventLogsDetail = this.eventLogs.filter(item => item.sn === this.sn).slice(0, 20);
        this.ngxService.stop();
      }
    });
    this.deviceDetails$ = this.store.select(fromStore.getDeviceDetails);
    this.packageSetting();
    
    this.store.select(fromStore.getGroupDevicesPageListView).subscribe(res => {
      this.deviceGroupList = (res || []).map((m) => ({
        ...m,
        data: m.data ? { ...m.data } : m.data,
        children: (m.children || []).map((c) => ({
          ...c,
          data: c.data ? { ...c.data } : c.data,
        })),
      }));
      const matchingGroups = [];
      this.deviceGroupList.map((m) => {
        if (m !== undefined) {
          if (m.children !== undefined) {
            const device = [];
            m.children.map((c) => {
              if (c.data.canTrial == undefined || !c.data.canTrial) {
                device.push({ ...c, data: { ...c.data } });
              }
            });
            const filteredChildren = device.filter(c => c.data && c.data.name);
            if (filteredChildren.length > 0) {
              matchingGroups.push({ data: { ...m.data }, children: filteredChildren });
            } else {
              matchingGroups.push({ data: { ...m.data }, children: [{data: {}}]});
            }
          } else {
            matchingGroups.push({ ...m, data: m.data ? { ...m.data } : m.data });
          }
        }
      });
      this.sortStatus(matchingGroups, 'warning');
      this.sortStatus(matchingGroups, 'critical');
    });
  }

  ngOnInit() {
    this.UI();
						
    this.deviceDetailSidebar = false;
    // this.selectedWaringDevice = null;
    // this.selectedCriticalDevice = null;
    this.selectedEvent = null;
    this.deviceDetail.image = '/assets/images/default_device.png';
  }

  getMspRegion() {
    this.ngxService.start();
    this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
  }

  packageSetting(): void {
    this.store.select(fromStore.getIsActiveUserModule, PackageList.Group).pipe(
      take(1),
      switchMap(res => {
      this.groupFeature = Boolean(res);
      return this.groupFeature
        ? this.deviceGroupList$ = this.store.select(fromStore.getGroupDevicesPageListView)
        : this.deviceList$ = this.store.select(fromStore.getWithoutGroupFeatureListView);
    }))
  }

  searchKeyWord(type) {
    const config = {
      warning: {
        keyWord: this.warningKeyWord,
        originalList: this.deviceWarningListStash,
        targetList: 'deviceWarningList'
      },
      critical: {
        keyWord: this.criticalKeyWord,
        originalList: this.deviceCriticalListStash,
        targetList: 'deviceCriticalList'
      }
    };

    const { keyWord, originalList, targetList } = config[type];

    if (!keyWord) {
      this[targetList] = [...originalList];
      return;
    }

    this[targetList] = originalList.filter(item =>
      item.name.toLowerCase().includes(keyWord.toLowerCase())
	  
    );
  }

  sortStatus(matchingGroups, type) {
    const getList = status => {
      const groups = matchingGroups.filter(item => item.data.type === 'Group')
        .flatMap(group => group.children.filter(child => child.data.status === status))
        .map(item => item.data);
      const devices = matchingGroups.filter(item => item.data.type !== 'Group' && item.data.status === status)
        .map(item => item.data);
      return [...groups, ...devices];
    };
    if (type === 'warning') {
      this.allDeviceWarningList = getList(type);
      this.allDeviceWarningListStash = [...this.allDeviceWarningList];
    } else if (type === 'critical') {
      this.allDeviceCriticalList = getList(type);
      this.allDeviceCriticalListStash = [...this.allDeviceCriticalList];
    }
    if (this.allDeviceWarningList.length > 0 || this.allDeviceCriticalList.length > 0) {
      this.getTreeRegion();
    }
  }

  errorHandler(event) {
    event.target.classList.add('sidebar-content-detail-img-bgGray');
    event.target.src = '/assets/images/default_device.png';
  }

  routeToDetailPage() {
    // this.deviceDetailSidebar = false;
    this.router.navigate(['/monitoring/device/detail', this.cryptoService.aesEncrypt(this.sn)]);
  }
  
  linkToEventMontioring() {
    if ( this.selectedRegion !== null && this.selectedRegion.data && Object.keys(this.selectedRegion.data).length > 0 ) {
      let status = '2';
      if (this.eventLogs.length > 0) {
        status = this.eventLogs.some(e => e.statusCode === 2) ? '2' : '1';
      }
      const paramStr = this.selectedRegion.data.Id + ',' + status;
      const hashStr = this.cryptoService.aesEncrypt(paramStr);
      if (hashStr) {
        // 勿在 path 後加 trailing slash，並避免 href="#" 蓋掉網址
        this.router.navigate(['/pro/monitoring/event', hashStr]);
      }
    }
  }
  
  linkToDeviceMontioring(event:any = null) {
    if ( this.selectedRegion !== null && this.selectedRegion.data && Object.keys(this.selectedRegion.data).length > 0 ) {
      const statusInt = parseInt(event.value, 10);
      const status = JSON.stringify([statusInt]);
      // paramStr = "MspMainRegionId,SelectRegionId,[StatusArray]"
      const paramStr = this.selectedRegion.data.MspMainRegionId + ',' + this.selectedRegion.data.Id + ',' + status;
      const hashStr = this.cryptoService.aesEncrypt(paramStr);
      if (hashStr) {
        this.router.navigate(['/management/pro/device', hashStr]);
      }
    }
  }

  getDeviceDetail(event, type) {
    if (type === 'event'){
      this.selectedWaringDevice = null;
      this.selectedCriticalDevice = null;
      this.sn = event.data.sn;

    } else if (type === 'warning' || type === 'critical' ) {
      if (type === 'warning') {
        this.selectedCriticalDevice = null;
        this.selectedEvent = null;
      } else if (type === 'critical') {
        this.selectedWaringDevice = null;
        this.selectedEvent = null;
      }
      if (event.isExpired) {
        this.deviceDetailSidebar = false;
        return;
      } else {
        this.sn = event.data.DeviceSN;
        if (event.data) {
          this.device_regionId = event.data.regionId;
          this.deviceDetail.is_shared = event.data.is_shared;
        }
      }
    }

    this.ngxService.start();

    this.store.dispatch(new fromFeature.GetEventMonitoring({ ...this.filterEventParam }));
    this.store.dispatch(new fromStore.GetDevicesDetails(this.sn));
  }

  onDeviceDetailHide() {
    this.selectedWaringDevice = null;
    this.selectedCriticalDevice = null;
    this.selectedEvent = null;
  }

  // 將資料轉換成TreeTable格式
  getTreeRegion() {
    const regionMap = new Map<number, any>();
    if (this.region !== undefined && this.region.length > 0) {
      this.treeRegion = this.region.map(i => {
        let totalCount = 0;
        let warningCount = 0;
        let criticalCount = 0;
        if (
          this.allDeviceStatus[i.Id] !== undefined &&
          this.allDeviceStatus[i.Id].all !== undefined &&
          this.allDeviceStatus[i.Id].all.all_count !== undefined &&
          this.allDeviceStatus[i.Id].warning.warning_count !== undefined &&
          this.allDeviceStatus[i.Id].critical.critical_count !== undefined
        ) {
          totalCount = this.allDeviceStatus[i.Id].all.all_count;
          warningCount = this.allDeviceStatus[i.Id].warning.warning_count;
          criticalCount = this.allDeviceStatus[i.Id].critical.critical_count;
        }
        return {
          data: {
            ...i,
            totalCount: totalCount,
            warningCount: warningCount,
            criticalCount: criticalCount
          },
          children: [],
          expanded: true
        };
      }) as any[];
  
      this.treeRegion.forEach(node => {
        regionMap.set(node.data.Id, node);
      });
  
      let transformedRegion: any[] = [];
      this.treeRegion.forEach(node => {
        const parentId = node.data.ParentRegionId;
        const mainRegionId = node.data.MspMainRegionId;
        if (node.data.Id === parentId || node.data.Id === mainRegionId) {
          transformedRegion.push(node);
        } else {
          const parentNode = regionMap.get(parentId);
          if (parentNode) {
            parentNode.children.push(node);
          } else {
            transformedRegion.push(node);
          }
        }
      });
  
      this.treeRegion = transformedRegion;
  
      // 預設選取第一筆資料
      if (this.treeRegion) {
        this.selectedRegion = this.treeRegion[0];
        if (this.allDeviceStatus[this.treeRegion[0].data.Id] !== undefined) {
          this.devicesTypeCount_Region = this.allDeviceStatus[this.treeRegion[0].data.Id].data;
          if (this.eventLog_Dic[this.treeRegion[0].data.Id] !== undefined) {
            this.eventLogs = this.eventLog_Dic[this.treeRegion[0].data.Id]
          }
          this.deviceWarningList = this.allDeviceWarningList.filter(w => w.regionId == this.treeRegion[0].data.Id);
          this.deviceWarningListStash = [...this.deviceWarningList];
          this.deviceCriticalList = this.allDeviceCriticalList.filter(c => c.regionId == this.treeRegion[0].data.Id);
          this.deviceCriticalListStash = [...this.deviceCriticalList];
        } else {
          if (this.treeRegion[0]["children"] !== undefined && this.treeRegion[0]["children"].length > 0) {
            if (this.allDeviceStatus[this.treeRegion[0]["children"][0].data.Id] !== undefined) {
              this.devicesTypeCount_Region = this.allDeviceStatus[this.treeRegion[0]["children"][0].data.Id].data;
              if (this.eventLog_Dic[this.treeRegion[0]["children"][0].data.Id] !== undefined) {
                this.eventLogs = this.eventLog_Dic[this.treeRegion[0]["children"][0].data.Id]
              }
              this.deviceWarningList = this.allDeviceWarningList.filter(w => w.regionId == this.treeRegion[0]["children"][0].data.Id);
              this.deviceWarningListStash = [...this.deviceWarningList];
              this.deviceCriticalList = this.allDeviceCriticalList.filter(c => c.regionId == this.treeRegion[0]["children"][0].data.Id);
              this.deviceCriticalListStash = [...this.deviceCriticalList];
            }
          }
        }
      }
    }
  }

  /** PrimeNG 20 SelectButton 可能綁整個 option 或 option.value，需相容兩者 */
  private resolveStatusValue(status: any): number {
    if (status != null && typeof status === 'object' && 'value' in status) {
      return parseInt(status.value, 10);
    }
    return parseInt(status, 10);
  }

  // For All
  statusChanged(event?: any) {
    if ( this.selectedRegion !== null && this.selectedRegion.data && Object.keys(this.selectedRegion.data).length > 0 ) {
      const raw = event && event.value !== undefined ? event.value : this.selectedStatus;
      const statusInt = this.resolveStatusValue(raw);
      if (Number.isNaN(statusInt)) {
        return;
      }
      const status = JSON.stringify([statusInt]);
      // paramStr = "MspMainRegionId,SelectRegionId,[StatusArray]"
      // 避免 ', -1 ,' 多餘空白，降低 hash 解析歧義
      const paramStr = this.selectedRegion.data.MspMainRegionId + ',-1,' + status;
      const hashStr = this.cryptoService.aesEncrypt(paramStr);
      if (hashStr) {
        this.router.navigate(['/management/pro/device', hashStr]);
      }
    }
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');

    const mainContent = self.innerHeight - 280 + 'px';
    const mainListContent = self.innerHeight - 320 + 'px';
    const mainContentHeight = document.getElementsByClassName('main-content')[0] as HTMLElement;
    const contentAreaHeight = document.getElementsByClassName('content-area')[0] as HTMLElement;
    const contentListHeight = document.getElementsByClassName('content-list')[0] as HTMLElement;
    mainContentHeight.style.height = mainContent;
    contentAreaHeight.style.height = mainContent;
    contentListHeight.style.height = mainListContent;

    const boardListHeight = self.innerHeight - 370 + 'px';
    const eventListHeight = self.innerHeight - 575 + 'px';
    const sideEventListHeight = self.innerHeight - 660 + 'px';
    this.boardListHeight = boardListHeight;
    this.eventListHeight = eventListHeight;
    this.sideEventListHeight = sideEventListHeight;
  }

  refresh() {
    this.ngxService.start();
    if (this.regionFilter !== null && this.regionFilter !== undefined) {
      // this.RangeParam.RegionIds = res.selectedId;
      this.mspSelectedRegionId = this.regionFilter.selectedId;
      const UserParam = {regionIds: this.regionFilter.selectedId} as User;
      this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
      this.store.dispatch(new fromStore.GetDeviceInfoAction({regionIds: this.regionFilter.selectedId}));
      this.filterDeviceParam = {
        ...this.filterDeviceParam,
        regionId: null,
      };
      this.filterEventParam = {
        ...this.filterEventParam,
        regionId: null,
        device_status: null,
      };
      this.store.dispatch(new fromFeature.LoadEventFilterss({ ...this.filterEventParam }));
      this.store.dispatch(new fromFeature.GetEventMonitoring({ ...this.filterEventParam }));
      this.store.dispatch(new fromFeature.GetDeviceMonitorings({ ...this.filterDeviceParam }));
      this.refreshTime = new Date();
      this.onDeviceDetailHide();
      this.deviceDetailSidebar = false;
    }
  }

  /** 無裝置的 region 顯示用零值狀態列 */
  private buildEmptyRegionStatusData(): any[] {
    return [
      { label: TRANSLATE('All'), value: '-1', title: 0 },
      { label: TRANSLATE('Normal'), value: '0', title: 0 },
      { label: TRANSLATE('Warning'), value: '1', title: 0 },
      { label: TRANSLATE('Critical'), value: '2', title: 0 },
      { label: TRANSLATE('Offline'), value: '3', title: 0 }
    ];
  }

  onRegionSelect(event: any): void {
    const selectedNode = event.node;
    if (selectedNode?.data === undefined) {
      return;
    }
    const regionStatus = this.allDeviceStatus[selectedNode.data.Id];
    if (regionStatus !== undefined) {
      this.devicesTypeCount_Region = regionStatus.data;
    } else {
      // 該公司沒有裝置時 allDeviceStatus 不會有資料，需清成 0，避免殘留上一間公司的統計
      this.devicesTypeCount_Region = this.buildEmptyRegionStatusData();
    }
    if (this.eventLog_Dic[selectedNode.data.Id] !== undefined) {
      this.eventLogs = this.eventLog_Dic[selectedNode.data.Id];
    } else {
      this.eventLogs = [];
    }
    this.deviceWarningList = this.allDeviceWarningList.filter(w => w.regionId == selectedNode.data.Id);
    this.deviceWarningListStash = [...this.deviceWarningList];
    this.deviceCriticalList = this.allDeviceCriticalList.filter(c => c.regionId == selectedNode.data.Id);
    this.deviceCriticalListStash = [...this.deviceCriticalList];
  }

  onRegionUnselect(event: any): void {
    setTimeout(() => {
      this.selectedRegion = event.node;
    });
  }
  

  selectionChange() {
    this.pageLoading = false;
  }

  onRowEventSelect(event: any) {
    this.getDeviceDetail(event,'event');
  }

  onRowEventUnselect(event: any) {
    this.deviceDetailSidebar = false;
  }

  onRowSelect(event: any, type) {
    this.getDeviceDetail(event,type);
  }

  onRowUnselect(event: any) {
    this.deviceDetailSidebar = false;
  }

  startInterval() {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        this.refresh();
      }, ReLoadDashboardSec * 1000);
      // console.log("計時器已啟動");
    }
  }
  
  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      // console.log("計時器已停止");
    }
  }

  ngOnDestroy() {
    this.stopInterval();
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

}
